import { ComboboxConfigMaster } from './ComboboxConfigMaster';

interface ConfigComboboxProps {
    categoryCode: string;
    value: string;
    onChange: (value: string) => void;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    hideLabel?: boolean;
    required?: boolean;
    valueField?: 'name' | 'code';
    className?: string;
    canAdd?: boolean;
}

export function ConfigCombobox({
    categoryCode,
    value,
    onChange,
    label,
    placeholder = 'Chọn...',
    disabled,
    hideLabel,
    required,
    valueField = 'name',
    className,
    canAdd,
}: ConfigComboboxProps) {
    return (
        <ComboboxConfigMaster
            categoryCode={categoryCode}
            value={value}
            onChange={onChange}
            label={label}
            placeholder={placeholder}
            disabled={disabled}
            hideLabel={hideLabel}
            required={required}
            valueField={valueField}
            className={className}
            canAdd={canAdd}
        />
    );
}

